import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import vodStore from './vodStore';

const reducer = (state, action) => {
  return combineReducers({
    vodStore
  })(state, action);
};

export default configureStore({
  reducer: reducer,
  // 개발 진행시 Redux state 관리 로그 화면
  // middleware: (base) => base({ serializableCheck: false }).concat(logger),
  middleware: (base) => base({ serializableCheck: false }),
});
